import React, { useEffect, useState } from 'react';
import LoadingDots from "../LoadingDots";
import Message from "../Message";
import Response from "../Response";
import ListingCard from "../ListingCard";
import ViewMoreButton from "./ViewMoreButton";
import { sendQuestionRequest, getListingDetails } from "../../utils/apiHandler";
import { useAuth0 } from "@auth0/auth0-react";

var sentRequestsDict = [];
const ChatComponent = ({ userMessage, pusherData, setDots, clientId, question_key, batch_count, handleNotesPopup, saveUnsaveListing, history_response, history_listings, messageResponse, inputMethod }) => {
    const [listingData, setListingData] = useState([]);
    const [listingDataCount, setListingDataCount] = useState({
        returned: 0,
        batch_count: batch_count
    });
    const [loading, setLoading] = useState(true);
    const { getIdTokenClaims, getAccessTokenWithPopup, logout, user } = useAuth0();
    const [displayViewMore, setDisplayViewMore] = useState(false);

    const removeSentRequestsDict = (key) => {
        sentRequestsDict.find((item, index) => {
            if (item === key) {
                sentRequestsDict.splice(index, 1);
            }
        })
    }

    useEffect(() => {
        pusherData?.map((data) => {
            if (data.question_key === question_key) {

                if (data.answer_hash) {
                    if(sentRequestsDict.includes(data.answer_hash)){
                        return;
                    }
                    sentRequestsDict.push(data.answer_hash);
                    getListingDetails(getIdTokenClaims, data.answer_hash, getAccessTokenWithPopup, logout)
                        .then(response => {
                            removeSentRequestsDict(data.answer_hash);
                            response.answer_hash = data.answer_hash;
                            setListingData(prevListings => {
                                // Prevent duplicate entries
                                if (prevListings.some(item => item.answer_hash === response.answer_hash)) {
                                    return prevListings;
                                }
                                return [...prevListings, response];
                            });
                            setListingDataCount(prevCount => ({
                                ...prevCount,
                                returned: prevCount.returned + 1
                            }));
                        })
                        .catch(error => {
                            console.log(error, "There is some error fetching listing data");
                            removeSentRequestsDict(data.answer_hash);
                        });
                }

                if (data.listing_id == null) {
                    setLoading(false);
                }
            }
        });
    }, [pusherData]);

    useEffect(() => {
        if (history_listings) {
            let listingDataTemp = [];

            history_listings.forEach((listing) => {
                listingDataTemp.push({
                    ...listing,
                    synopsis: listing.answer,
                    media: [{
                        url: listing.hero_image
                    }]
                });
            });
            setListingData(listingDataTemp);
        }
    }, []);

    useEffect (() => {
        if(listingData && batch_count > 4 && !displayViewMore){
            setTimeout(() => {
                setDisplayViewMore(true);
            }, 6000);
        }
    }, [listingData]);

    return (
        <div id="chatBoxContainer" className="mx-2 px-2 lg:mx-4 lg:px-4 mb-2 lg:mb-4">
            <Message text={userMessage} userName={user?.first_name + user?.last_name} inputMethod={inputMethod} />
            {messageResponse || history_response ? (
                <div>
                    {!history_response && <Response text={messageResponse} inputMethod={inputMethod} />}
                    {listingData && (
                        <div id={`listingGrid_${question_key}`}>
                            <div className="listing grid pt-6 pb-6 lg:pt-8 lg:pb-8 gap-4">
                                {
                                    listingData.map((item, index) =>
                                        <ListingCard
                                            key={index}
                                            listing={item}
                                            clientId={clientId}
                                            setNotesPopup={handleNotesPopup}
                                            saveUnsaveListing={saveUnsaveListing}
                                        />)
                                }
                            </div>
                            {/* View More Button - Show only if there are more listings to display */}
                            {displayViewMore && listingDataCount.returned < listingDataCount.batch_count && !history_response && (
                                <ViewMoreButton
                                    questionKey={question_key}
                                    clientId={clientId}
                                    getIdTokenClaims={getIdTokenClaims}
                                    getAccessTokenWithPopup={getAccessTokenWithPopup}
                                    logout={logout}
                                />
                            )}
                        </div>
                    )}
                </div>
            ) : loading ? (
                <div className="py-4 md:mr-28">
                    <LoadingDots setDots={setDots} />
                </div>
            ) : (
                <Response text="Unexpected Error." inputMethod={inputMethod} />
            )}
        </div>
    );
};

export default ChatComponent;